import React from 'react';
import PropTypes from 'prop-types';
import BasicInput from '../ui/BasicInput';
import SendBudgetButton from '../ui/SendBudgetButton';
import { validateEmail } from '../../functions';
import sendBudget from './budget';

export class BudgetSender extends React.Component {
  constructor(props) {
    super(props);
    const agentId = props.agentId;
    this.state = {
      isLoading: false,
      justSent: false,
      agentId: agentId,
    };
  }

  onSendClick = async () => {
    if (this.state.justSent) return;
    const errorEmail = validateEmail(this.state.email);

    if (!errorEmail) {
      this.setState({ isLoading: true });
      try {
        await sendBudget({
          product: this.props.product,
          form: this.props.calculatorForm,
          email: this.state.email,
          agentId: this.state.agentId,
        });
        this.setState({
          isLoading: false,
          justSent: true,
        });
      } catch (err) {
        console.error(err);
        this.setState({ isLoading: false });
        alert('Se ha producido un error, inténtelo más tarde.');
      }
    } else {
      this.setState({ errorEmail: errorEmail });
    }
  };

  onEmailChangeValue = (value) => {
    this.setState({
      errorEmail: undefined,
      justSent: false,
      email: value,
    });
  };

  render() {
    return (
      <div className="u-margin-top u-text-left">
        <div style={{ maxWidth: '440px', margin: 'auto' }}>
          <p className="u-margin-bottom-small">
            Indica el correo electrónico al que enviaremos la propuesta
          </p>
          <BasicInput
            placeholder="Correo electrónico"
            type="email"
            error={this.state.errorEmail}
            onChange={(evt) => this.onEmailChangeValue(evt.target.value)}
          />
        </div>
        <SendBudgetButton
          className="u-margin-top"
          isLoading={this.state.isLoading}
          justSent={this.state.justSent}
          onClick={() => this.onSendClick()}
        />
      </div>
    );
  }
}

BudgetSender.propTypes = {
  calculatorForm: PropTypes.object,
  product: PropTypes.string.isRequired,
};

export default BudgetSender;



// WEBPACK FOOTER //
// ./src/components/BudgetSender/index.js